import React from 'react';
import { useIntl } from 'react-intl';
import { useFragment, graphql, useMutation } from 'react-relay/hooks';
import { Flexbox, Switch } from '@sonika-se/ui-kit/components';
export const EditEventIsWork = (props) => {
    const { eventRef } = props;
    const intl = useIntl();
    const { id, isWork } = useFragment(graphql `
      fragment EditEventIsWork_event on Event {
        id
        isWork
      }
    `, eventRef);
    const [updateEvent, updateEventLoading] = useMutation(graphql `
    mutation EditEventIsWorkMutation($model: UpdateEventRequestInput!) {
      updateEvent(model: $model) {
        eventEdge {
          node {
            id
            isWork
          }
        }
      }
    }
  `);
    return (<Flexbox align="center">
      <Switch disabled={updateEventLoading} checked={isWork} label={intl.formatMessage({
            id: 'EventSettings.isWork',
            defaultMessage: 'Är arbete',
        })} onChange={() => {
            updateEvent({
                variables: {
                    model: {
                        id,
                        isWork: !isWork,
                    },
                },
            });
        }}/>
    </Flexbox>);
};
export default EditEventIsWork;
